import React, {Component} from 'react';
import {Link} from 'react-router-dom';

export default class WorkList extends Component{

    constructor(props) {
        super(props);
        this.state = {
            posts: []
        };
    }

    componentDidMount() {
        const reference = this.props.reference;
        if (reference) {
            reference.once('value', this.handleList.bind(this));
        }
    }

    handleList(snapshot) {
        const posts = [];
        snapshot.forEach(function (childsnap) {
            const post = childsnap.val();
            posts.push(post);
        });
        this.setState({posts:posts});
    }

    render() {
        const posts = this.state.posts;
        return (
            posts.map(({key, title}) => <li className="list-group-item" key={key}><Link to={`/${this.props.url}/${key}`}>{title}</Link></li>)
        );
    }
}


// WEBPACK FOOTER //
// ./src/admin/components/editor/WorkList.js